import { BaseCall } from '../BaseCall'
import { APIConfig } from '../interfaces'

export interface VersionChange {
	changeType: string
	description: string
}

export interface Version {
	changes: VersionChange[]
	versionDate: string
	versionNumber: string
	versionType: string
}

export interface ChangeLogs {
	versions: Version[]
	productName: string
	title: string
}

export class Logs extends BaseCall {
	// Logs Routes

	public getServerLogs = (): Promise<string> => this.client.get('/view/dev/logs').then((response) => response.data)

	public getRegionChangeLog = (): Promise<any> => this.client.get('/userdata/region-change-log').then((response) => response.data)

	public getRegionChangeLogByUserId = (userId: string): Promise<{ data: any[]; totalCount: number }> =>
		this.client.get(`/userdata/region-change-log/user/${userId}`).then((response) => response.data)

	public getChangeLogs = async (product: string, environment: string, os: string): Promise<ChangeLogs | undefined> => {
		try {
			const changeLogsResponse = await this.client.get<ChangeLogs>(`/view/change-logs/${product}/${environment}/${os}`, {
				withCredentials: true
			})

			return changeLogsResponse.data
		} catch (e) {
			// console.log(e)
		}
	}

	public getUserData = (params: any): Promise<any> => this.client
			.get(`/userdata/users`, {
				params: params
			})
			.then((response) => response.data)

	public getRegistrationsData = async (params: any): Promise<any> => {
		const res = await this.client.get(`/userdata/registrations`, { params: params })

		return res.data
	}

	public setConfig(config: APIConfig): void {
		this.setBaseUrl(config.API_SERVER)
	}
}
